/**
 * Sliders can be used in different plugins and extensions.
 * Each slider may even have a different setting, overwriting the default ones.
 * All those settings are inside specific data- attributes and coincide with 
 * the names of the defaultConfig just all lowercase and with dashes. Example:
 * data-slides-to-scroll="2" data-slides-to-show="3" etc
 * 
 * Those data attributes are read by DOMStringMap, which contains all data attributes
 * in camelCase format, making the check for existence a lot faster for N sliders on a page.
 * Unless the user is using IE < 11, then DOMStringMap is not available and we fallback to getAttribute.
 * Basically old browsers get the slow function.
 * 
 * You can only overwrite settings that are inside the defaultConfig.
 */
// Check if new feature DOMStringMap is available, if so we loop over that instead of the defaultConfig to save time
let datasetAvailable = false;
try {
	datasetAvailable = document.body.dataset !== undefined;
} catch (e) {
	// 
}
// Taken from https://github.com/jonschlinkert/dashify, used for IE support of data-abc-xyz attributes
// can't be imported/required as outlined in docs due to "invalid assignment" error on uglify
let funcDashify = str=> str.trim()
					.replace(/([a-z])([A-Z])/g, '$1-$2')
					.replace(/\W/g, m => /[À-ž]/.test(m) ? m : '-')
					.replace(/^-+|-+$/g, '')
					.toLowerCase();

/**
 * This is the default slider configuration, 
 * most of them are default values and only listed to enable
 * overwriting features inside DOM elements.
 * Not all default values are listed here.
 * Mostly primitive types (no selectors) are listed,
 * and only the more important ones.
 * 
 * No one ever uses "edgeFriction" etc.
 */
let defaultConfig = {
	accessibility: true,
	adaptiveHeight: false,
	autoplay: false,
	autoplaySpeed: 3000,
	arrows: true,
	asNavFor: null,
	centerMode: false,
	centerPadding: '50px',
	dots: false,
	infinite: false,
	initialSlide: 0,
	pauseOnDotsHover: false,
	rows: 1,
	slidesToShow: 3,
	slidesToScroll: 1,
	swipe: true,
	touchMove: true,
	variableWidth: true,
	zIndex: 1000,

	responsive: [
		{
			breakpoint: 1675,
			settings: {
				slidesToShow: 2,
				centerMode: false,
				infinite: true,
			}
		},
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
				variableWidth: false,
				centerMode: false,
				infinite: true,
			}
		}
	]
};
let configKeys = Object.keys(defaultConfig);

// Get all available sliders on the page
let sliders = Array.prototype.slice.call(document.querySelectorAll('.js-slider'));
// Loop over every single one
sliders.forEach(slider => {
	// Copy default config
	let sliderConfig = $.extend({}, defaultConfig);  // IE does not support Object.assign but we have jQuery, rather us jQ than polyfill (here)
	// use fancy, performant new dataset element property to loop over
	if (datasetAvailable) {
		// Get camelCased data-* attributes
		let sliderAttr = Object.keys(slider.dataset);
		// Loop over them and check if they are present in the defaultConfig, if so add that value
		sliderAttr.forEach( attr => {
			if (typeof (defaultConfig[attr]) !== 'undefined') {
				if (attr === "responsive" && typeof(window[slider.dataset[attr]]) !== 'undefined') {
					sliderConfig[attr] = window[slider.dataset[attr]];
				} else {
					let val = slider.dataset[attr];
					if (val === "true" || val === "false") {
						val = val === "true";
					} else if (!isNaN(val)) {  // "5" => true, "5f" => false, not a number
						val = parseFloat(val, 10);
					}  // else it's considered a string, do not convert then

					sliderConfig[attr] = val;
				}
			}
		});
	// IE < 11 has no dataset
	} else {
		// for each slider on a page loop over the entire defaultConfig keys
		// and check if the element has an attribute with that name via getAttribute and add to slider config if true
		configKeys.forEach(cfgKey => {
			let attrVal = slider.getAttribute(`data-${funcDashify(cfgKey)}`);
			if (attrVal) {
				if (cfgKey === "responsive" && typeof(window[attrVal]) !== 'undefined') {
					sliderConfig[cfgKey] = window[attrVal];
				} else {
					let val = attrVal;
					if (val === "true" || val === "false") { val = val === "true"; }
					else if (!isNaN(val)) { val = parseFloat(val, 10); }

					sliderConfig[cfgKey] = val;
				}
			}
		});
	}

	// create the slider with the config
	$(slider).slick(sliderConfig);
});